// extracted by mini-css-extract-plugin
export var chip = "_4o-0";
export var filterDropdown = "_4o-5";
export var filterItem = "_4o-6";
export var icon = "_4o-1";
export var removeButton = "_4o-3";
export var removeIcon = "_4o-4";
export var separator = "_4o-2";